import { Page, PageHero } from "../components/Layout";
import { AboutStory, EthicsSection, GlobalReachSection, PurposeSection } from "../components/about/AboutSections";

export default function About() {
  return (
    <Page testId="about-page">
      <PageHero image="/assets/bg-about.jpg" eyebrow="About Vardhamaan" title={<>Two decades of connecting <span className="text-[#D4AF37]">talent with opportunity.</span></>} sub="Established in the early 2000s, Vardhamaan has evolved from a small manpower startup into a full-fledged, ISO-certified international organization." />
      <AboutStory />
      <PurposeSection />
      <GlobalReachSection />
      <EthicsSection />
    </Page>
  );
}